export type Struct<V = any> = Record<string, V>;

export function isNotNullOrUndefined<T>(v: T | null | undefined): v is T {
  return v != null;
}

export function assertUnreachable(x: never): never {
  throw new Error('unreachable code');
}
